// extracted by mini-css-extract-plugin
export default {"loading":"index_loading_oUKEg","loadingIcon":"index_loadingIcon_zK6tj","footer":"index_footer_e9rib","loading_img":"index_loading_img_Xgtvx","rotate":"index_rotate_DIaXA"};